import React from 'react';
import { ShieldCheck, Wrench, Clock, LockKeyhole } from 'lucide-react';
import Footer from './Footer';

export default function MaintenancePage({ siteMode, onAdminSignIn }) {
  return (
    <div className="min-h-screen bg-mentor-bg flex flex-col relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-[-160px] left-[-120px] w-96 h-96 rounded-full bg-mentor-accent/10 blur-3xl" />
        <div className="absolute bottom-[-180px] right-[-140px] w-[30rem] h-[30rem] rounded-full bg-signal-yellow/10 blur-3xl" />
      </div>

      <main className="flex-1 flex items-center justify-center px-4 py-12 relative z-10">
        <section className="glass-card max-w-3xl w-full p-8 md:p-10 border border-mentor-border/70 text-center animate-fade-in">
          <div className="mx-auto w-20 h-20 rounded-3xl bg-mentor-accent/15 border border-mentor-accent/25 flex items-center justify-center mb-6 shadow-glow">
            <Wrench size={38} className="text-mentor-accent" />
          </div>

          <p className="text-xs font-display font-bold text-mentor-muted uppercase tracking-[0.3em] mb-3">
            Bond Mentor Maintenance Mode
          </p>
          <h1 className="text-3xl md:text-5xl font-display font-bold text-mentor-text leading-tight mb-4">
            We&apos;re making Bond Mentor better.
          </h1>
          <p className="text-base md:text-lg text-mentor-muted font-body leading-relaxed max-w-2xl mx-auto">
            {siteMode?.message || "Bond Mentor is temporarily offline for updates. We'll be back shortly — your account, saved preferences, alerts, and dashboard access are safe."}
          </p>

          {siteMode?.estimatedReturn && (
            <div className="mt-6 inline-flex items-center gap-2 rounded-full border border-mentor-border/60 bg-mentor-panel/70 px-4 py-2 text-sm text-mentor-muted">
              <Clock size={15} className="text-mentor-accent" />
              Estimated return: <span className="text-mentor-text font-display font-bold">{siteMode.estimatedReturn}</span>
            </div>
          )}

          <div className="grid md:grid-cols-3 gap-3 mt-8 text-left">
            <div className="rounded-2xl border border-mentor-border/50 bg-mentor-panel/50 p-4">
              <ShieldCheck size={20} className="text-signal-green mb-2" />
              <p className="text-sm font-display font-bold text-mentor-text">Your access is safe</p>
              <p className="text-xs text-mentor-muted mt-1">Account details and settings remain protected while updates run.</p>
            </div>
            <div className="rounded-2xl border border-mentor-border/50 bg-mentor-panel/50 p-4">
              <Wrench size={20} className="text-mentor-accent mb-2" />
              <p className="text-sm font-display font-bold text-mentor-text">Updates in progress</p>
              <p className="text-xs text-mentor-muted mt-1">This mode helps prevent users from seeing broken or unsafe pages.</p>
            </div>
            <div className="rounded-2xl border border-mentor-border/50 bg-mentor-panel/50 p-4">
              <LockKeyhole size={20} className="text-signal-yellow mb-2" />
              <p className="text-sm font-display font-bold text-mentor-text">Admin bypass</p>
              <p className="text-xs text-mentor-muted mt-1">Admin users can still sign in to switch the site back on.</p>
            </div>
          </div>

          <button
            type="button"
            onClick={onAdminSignIn}
            className="mt-8 px-5 py-3 rounded-xl bg-mentor-accent text-mentor-bg font-display font-bold hover:shadow-glow transition-all"
          >
            Admin Sign In
          </button>

          <p className="text-[11px] text-mentor-muted mt-5 font-body">
            Mode source: {siteMode?.source === '.env' ? '.env override' : 'Admin saved setting'}
          </p>
        </section>
      </main>
      <Footer />
    </div>
  );
}
